import "@/App.css";
import { useEffect, useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Seo from "@/components/Seo";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Sectors from "@/components/landing/Sectors";
import Clients from "@/components/landing/Clients";
import Stats from "@/components/landing/Stats";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import Contact from "@/components/landing/Contact";
import EventBanner from "@/components/landing/EventBanner";
import Footer from "@/components/landing/Footer";
import YoutubeStream from "@/pages/YoutubeStream";
import EventPage from "@/pages/EventPage";

const Landing = () => {
  return (
    <div data-testid="landing-page">
      <Seo
        title="Urzu Media | PR, Communications, Digital Marketing & Events"
        description="Urzu Media is an integrated media & communications company with nearly a decade of experience delivering PR, digital marketing, conferences, summits and awards for industry, government and institutions."
      />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Sectors />
        <Clients />
        <Stats />
        <WhyChooseUs />
        <Contact />
        <EventBanner />
      </main>
      <Footer />
    </div>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  // Remove the generic platform-injected meta description so our
  // brand/SEO description remains the single source of truth.
  useEffect(() => {
    const clean = () => {
      const metas = Array.from(document.querySelectorAll('meta[name="description"]'));
      metas.forEach((m) => {
        if ((m.getAttribute("content") || "").includes("emergent.sh")) m.remove();
      });
      const remaining = Array.from(document.querySelectorAll('meta[name="description"]'));
      remaining.slice(0, -1).forEach((m) => m.remove());
    };
    clean();
    const obs = new MutationObserver(clean);
    obs.observe(document.head, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/event" element={<EventPage />} />
            <Route path="/youtube-stream" element={<YoutubeStream />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
